import { Card } from "react-bootstrap";

interface DataCutterDataSetsProps {
  boundary?: string;
}

const DataCutterDataSets = ({ boundary }: DataCutterDataSetsProps) => {
  return (
    <>
      <Card className="mb-2">
        <Card.Header>Point of Interest (POI)</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img src="/poi.svg" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              POI data refers to GIS data that identifies specific locations of
              interest within a given area. These points can include a wide
              variety of places such as public amenities, retail locations, and
              many more and is categorised to aid your search. POI data can be
              used in{" "}
              <a href="https://basemap.co.uk/tracc" target="_blank">
                TRACC
              </a>{" "}
              to create destinations. For example, you could import healthcare
              related destinations in order to indentify accessiblity to
              healthcare services.
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img src="/OSPOI.png" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <h5>OS POI</h5>
              <p>
                Ordnance Survey provide OS POI for England, Wales and Scotland.
                It is the most detailed point dataset available for these
                regions, listing the locations of over 4 million different
                places, with precise co-ordinates allowing them to be accurately
                placed on a map. The data is available under the following
                groups: Accommodation, Eating, Drinking, Commercial Services,
                Attractions, Sport, Entertainment, Education, Health,
                Infrastructure, Manufacturing, Production, Retail and Transport.
                Data is supplied as a CSV or Shapefile.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20POI`
                  : `/datasets/OS%20POI`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS POI Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img src="/OSMPOI.png" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <h5>OSM POI</h5>
              <p>
                From OpenStreetMap, POI is a dataset providing over 150 million
                locations worldwide. These include accurate locations as well as
                other useful metadata such as name, addresses, opening times and
                so on. It is categoriesed to simplify its selection into:
                Accommodation, Catering, Education, Leisure, Shopping, Tourism,
                Places of Worship, Transport and more. The data is supplied as a
                CSV or Shapefile.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OSM%20POI`
                  : `/datasets/OSM%20POI`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OSM POI Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>Public Transport TimeTables</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img
            src="/pt-network.svg"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <p>
                The most comprehensive supply of digital timetables data showing
                full trip information for rail, bus, coach, ferry, tram, tube
                and other minor modes of transport. The data is available
                worldwide as as a quarterly snapshot and can be used to drive
                public transport travel times or working out stop frequency
                information. The UK data goes back as far as 2015, while
                worldwide data is our new offering in DataCutter starting 2025.
                The data is supplied as a GTFS, CIF or TXC file, which can be
                read by software like{" "}
                <a href="https://basemap.co.uk/tracc" target="_blank">
                  TRACC
                </a>
                .
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/Public%20Transport%20TimeTables`
                  : `/datasets/Public%20Transport%20TimeTables`
                }
                className="btn btn-primary"
                role="button"
              >
                Get Public Transport TimeTables Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>Bus Route Lines</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img
            src="/routelines.svg"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <p>
                A digitized visual dataset showing all the bus route lines for
                Great Britain. This data can be sorted by operator, route and
                further queried to find out route frequencies. The data is
                provided as a Shapefile. For technical details please click{" "}
                <a href="Basemap_RoutelinesDataV1.2.pdf" target="_blank">
                  here
                </a>
                .
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/Bus%20Route%20Lines`
                  : `/datasets/Bus%20Route%20Lines`
                }
                className="btn btn-primary"
                role="button"
              >
                Get Bus Route Lines Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>NaPTAN</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img src="/bus-stop.svg" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <p>
                This is the most detailed public transport stop data consisting
                of almost 500,000 stop locations. This shows every stop in Great
                Britain. The data includes the stop co-ordinate and is provided
                as a CSV file.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/naptan`
                  : `/datasets/naptan`
                }
                className="btn btn-primary"
                role="button"
              >
                Get NaPTAN Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>Road Network</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img
            src="/roadnetwork.svg"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              Digital polyline road networks supplied which can be used by
              GIS/Mapping systems such as{" "}
              <a href="https://basemap.co.uk/tracc" target="_blank">
                TRACC
              </a>{" "}
              and can be used to route. DataCutter provides several options:
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img src="/OSMRoads.png" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <h5>OSM Roads</h5>
              <p>
                Provided by OpenStreetMap, OSM Roads provides a worldwide
                dataset containing over 240 million roadlinks as well as
                relevant restrictions. The data may be used commercially and is
                supplied as GML3 or the OSM format.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OSM%20Roads`
                  : `/datasets/OSM%20Roads`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OSM Roads Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img
            src="/OpenRoads.png"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <h5>OS OpenRoads</h5>
              <p>
                Provided by Ordnance Survey, the most detailed freely available
                dataset on the market containing all major and minor roads in
                Great Britain, consisting of over 4 million links, which can be
                used commercially; provided as a Shapefile.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20OpenRoads`
                  : `/datasets/OS%20OpenRoads`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS OpenRoads Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img
            src="/HighwaysRRAMI.png"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <h5>OS Highways RAMI</h5>
              <p>
                A highly-detailed and accurate road network showing all the
                curves and kinks in the road. It contains all road types as well
                as comprehensive information on one-way streets, over a million
                banned turns, time and vehicle based restrictions. This is
                available to the public sector for free with a PSGA licence or
                can be purchased in small chunks via DataCutter; provided as a
                GML file.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20Highways%20RAMI`
                  : `/datasets/OS%20Highways%20RAMI`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS Highways Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img
            src="/HighwaysPaths.png"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <h5>OS Highways Paths</h5>
              <p>
                The most accurate and authoritative footpath and cyclepath
                network that links back into the OS Highways RAMI network. This
                contains thousands of km's of path data in Great Britain and is
                the definitive network for walking and cycling travel times.
                This is also available for free to the public sector with a PSGA
                licence or to be purchased in DataCutter; supplied as GML file
                and requires the OS Highways RAMI to provide a complete network.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20Highways%20Paths`
                  : `/datasets/OS%20Highways%20Paths`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS Highways Paths Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
        <div className="d-flex flex-row align-items-start border-top">
          <Card.Img src="/MRN.png" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <h5>OS MRN</h5>
              <p>
                Ordnance Survey's Multi-Modal Routing Network is a fully
                connected network dedicated for the multi-modal routing of
                people and goods, designed for use in routing applications such
                as{" "}
                <a href="https://basemap.co.uk/tracc" target="_blank">
                  TRACC
                </a>
                . It contains connectivity between different modal networks and
                key transport sites, along with road restriction information and
                speed data. The data is provided in PBF format.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20MRN`
                  : `/datasets/OS%20MRN`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS MRN Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>Census</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img src="/census.svg" style={{ width: 80 }} className="m-3" />
          <Card.Body>
            <Card.Text>
              <p>
                Census statistics help paint a picture of Great Britain and how
                we live. They provide a detailed snapshot of the population and
                its characteristics, and underpin funding allocation to provide
                public services. Census data is available for England and Wales
                in 2011 and 2021, as well as Scotland in 2022. It is available
                at different output areas, giving the most accurate freely
                available demographic dataset in Great Britain. The data is
                available in Excel, CSV or Shapefile.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/Census`
                  : `/datasets/Census`
                }
                className="btn btn-primary"
                role="button"
              >
                Get Census Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
      <Card className="mb-2">
        <Card.Header>OS Code-Point Open</Card.Header>
        <div className="d-flex flex-row align-items-start">
          <Card.Img
            src="/CodePoint.png"
            style={{ width: 80 }}
            className="m-3"
          />
          <Card.Body>
            <Card.Text>
              <p>
                This postcode dataset provides the most detailed postcode
                location data for Great Britain, featuring over 1.7 million
                postcode points with precise coordinates, delivered in a CSV
                format.
              </p>
              <a
                href={
                  boundary ?
                    `/boundaries/${boundary}/OS%20Code-Point%20Open`
                  : `/datasets/OS%20Code-Point%20Open`
                }
                className="btn btn-primary"
                role="button"
              >
                Get OS Code-Point Open Data
              </a>
            </Card.Text>
          </Card.Body>
        </div>
      </Card>
    </>
  );
};

export default DataCutterDataSets;
